import React from 'react';

function SectionHeader({ title, description, actions, breadcrumb }) {
  return (
    <div className="admin-page-header">
      {breadcrumb && <div style={{ fontSize: '12px', color: 'var(--admin-text-muted)', marginBottom: '6px' }}>{breadcrumb}</div>}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '12px' }}>
        <div>
          <h1 className="admin-page-title">{title}</h1>
          {description && <p className="admin-page-desc">{description}</p>}
        </div>
        {actions && <div className="admin-btn-group">{actions}</div>}
      </div>
    </div>
  );
}

export default SectionHeader;
